import {APP_INITIALIZER, Injector, LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from "../environments/environment";
import {HttpLoaderFactory, SharedModule} from "./shared/shared.module";
import {OverlayModule} from "./overlay/overlay.module";
import {EmbedVideoModule} from "./embed-video/embed-video.module";
import { GraphQLModule } from './graphql.module';
import {DirectivesModule} from "./directives/directives.module";
import { BreadcrumbModule } from "xng-breadcrumb";
import { BreadcrumbService } from 'xng-breadcrumb';
import { LottieModule } from 'ngx-lottie';
import {AtomsModule} from "./atoms/atoms.module";
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LOCATION_INITIALIZED} from "@angular/common";
import * as de from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import {AuthModule} from "./auth/auth.module";

// Lottie: Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return import(/* webpackChunkName: 'lottie-web' */ 'lottie-web');
}

export function appInitializerFactory(translate: TranslateService, injector: Injector) {
  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      const langToSet = 'de'
      translate.setDefaultLang('de');
      translate.use(langToSet).subscribe(() => {
        // console.info(`Successfully initialized '${langToSet}' language.'`);
      }, err => {
        console.error(`Problem with '${langToSet}' language initialization.'`);
      }, () => {
        resolve(null);
      });
    });
  });
}

const internalUri = environment.graphqlUrlInternal; // <-- add the URL of the GraphQL server here

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    StoreModule.forRoot(reducers, {metaReducers}),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    SharedModule,
    OverlayModule,
    EmbedVideoModule,
    AuthModule.forRoot(),
    GraphQLModule,
    DirectivesModule,
    BreadcrumbModule,
    LottieModule.forRoot({player: playerFactory}),
    AtomsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'de',
      loader: {
        provide: HttpLoaderFactory,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true
    },
    BreadcrumbService
  ],
  exports: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    registerLocaleData(de.default);
  }
}
